export const Close = (h) => (props) => (h("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", "aria-hidden": "true", viewBox: "0 0 24 24" }, h("path", { d: "m4 4 16 16M4 20 20 4" })));
//# sourceMappingURL=Close.js.map
